import { h, Component, Host, State, Element, Prop, Watch } from "@stencil/core";
import { ColorableComponent, applySchemeDelegate, setCssVariablesDelegate } from "../../common/colorable-component";
import {
  PreloaderCircleSchemeDefinition,
  PreloaderCircleSchemeName,
  PreloaderCircleSize
} from "./constants/preloader-circle-types";
import {
  PRELOADER_CIRCLE_SCHEME_CONFIG,
  PRELOADER_CIRCLE_SCHEME_MAP,
  PRELOADER_CIRCLE_SIZE_NORMAL,
  PRELOADER_CIRCLE_SIZE_SMALL
} from "./constants/preloader-circle-constants";
import pfx from "../../utils/style-class-prefix-helper";
import { PreloaderCircleSchemeConfiguration } from "../../constants/colors";
// import { InitLogging } from "../../decorators/init-logging";

@Component({
  tag: "eon-ui-preloader-circle",
  styleUrl: "preloader-circle.scss",
  shadow: true
})
export class PreloaderCircle
  implements ColorableComponent<PreloaderCircleSchemeConfiguration<PreloaderCircleSchemeDefinition>> {
  // @InitLogging() sentryTransaction;
  schemeConfig: PreloaderCircleSchemeConfiguration<PreloaderCircleSchemeDefinition> = PRELOADER_CIRCLE_SCHEME_CONFIG;
  schemeMap = PRELOADER_CIRCLE_SCHEME_MAP;

  /**
   * The components active scheme. If {@link scheme} is set, it will be set to the corresponding scheme.
   * If not set, the component will try to calculate it based on the nearest enclosing background information given by inner-background attribute or eon-ui-background component.
   */
  @State() activeScheme: PreloaderCircleSchemeDefinition;
  @State() colorful: boolean;

  @Element() hostElement: HTMLEonUiPreloaderCircleElement;

  /**
   * The name of the color scheme of the component.
   * If not set, the component will try to calculate it based on the nearest enclosing background information given by inner-background attribute or eon-ui-background component.
   */
  @Prop({ reflect: true }) scheme: PreloaderCircleSchemeName;

  /**
   * Defines radius for preloader
   */
  @Prop({ reflect: true }) size: PreloaderCircleSize = PRELOADER_CIRCLE_SIZE_NORMAL;

  componentWillLoad() {
    this.applyScheme();
  }

  componentDidLoad() {
    this.setCssVariables();
  }

  @Watch("scheme")
  applyScheme() {
    applySchemeDelegate(this);
    this.activeScheme === this.schemeConfig.colorful ? (this.colorful = true) : (this.colorful = false);
  }

  @Watch("activeScheme")
  setCssVariables(): void {
    setCssVariablesDelegate(this);
  }

  render() {
    return (
      <Host>
        <div
          class={pfx({
            "preloader-wrapper": true,
            colorful: !!this.colorful,
            small: this.size === PRELOADER_CIRCLE_SIZE_SMALL
          })}
        >
          <div class={pfx("preloader-spinner")}>
            {this.size === PRELOADER_CIRCLE_SIZE_SMALL ? (
              <svg viewBox="0 0 40 40" width="40" height="40">
                <circle class="track" cx="20" cy="20" r="12"></circle>
                <circle class="spinner" cx="20" cy="20" r="12"></circle>
              </svg>
            ) : (
              <svg viewBox="0 0 64 64" width="64" height="64">
                <circle class="track" cx="32" cy="32" r="24"></circle>
                <circle class="spinner" cx="32" cy="32" r="24"></circle>
              </svg>
            )}
          </div>
        </div>
      </Host>
    );
  }
}
